import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useFlow } from '../context/FlowContext';
import useWidgetStore from '../store/useWidgetStore';
const NoNav = ({ children }) => {
    const [showSummary, setShowSummary] = useState(false);
    const hasBooking = useWidgetStore((state) => state.hasBooking);
    const { currentRoute } = useFlow();
    useEffect(() => {
        var _a;
        setShowSummary(hasBooking === true && !['select', 'select1', 'select2', 'summary', 'thankYou'].includes((_a = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.route) !== null && _a !== void 0 ? _a : ''));
    }, [currentRoute]);
    return (_jsx(_Fragment, { children: _jsx(Box, { sx: {
                flexGrow: 1,
                paddingTop: showSummary ? '60px' : 0
            }, children: _jsx(Box, { sx: { padding: 1, width: '100%', minHeight: '100vh', maxWidth: 'calc(100vw - 16px)' }, children: children }) }) }));
};
export default NoNav;
